<template>
<div id="app" class="d-flex flex-column justify-content-center align-items-center">
  <img class="my-5 img-fluid" src="./assets/logo.svg">
  <div class="box">
    <div class="container">
      <div class="row">
        <div class="col-xl-6">
          <h6>Bill</h6>
     
      <input type="text" placeholder="0" v-model="bill" id="bill"/>
      
          <div class="dollar"><img src="./assets/icon-dollar.svg"></div>

          <h6>Select Tip %</h6>
          <div class="row">
            <div class="col-4 percents">
            <div class="percents-single">
              <input class="form-check-input" name="num[]" type="radio" value="5" id="5" @click="checagem">
              <label class="form-check-label align-middle" id="selecionado" for="5" @click="percent5">5%</label>
            </div><!--percents-single-->
            </div><!--col-->

            <div class="col-4 percents">
              <div class="percents-single">
              <input class="form-check-input" name="num[]" type="radio" value="10" id="10" >
              <label class="form-check-label align-middle" id="selecionado2" for="10" @click="percent10">10%</label>
            </div><!--percents-single-->
            </div><!--col-->

            <div class="col-4 percents">
              <div class="percents-single">
              <input class="form-check-input" name="num[]" type="radio" value="15" id="15">
              <label class="form-check-label align-middle" id="selecionado3" for="15" @click="percent15">15%</label> 
            </div><!--percents-single-->
            </div><!--col-->

            <div class="col-4 percents">
              <div class="percents-single">
              <input class="form-check-input" name="num[]" type="radio" value="25" id="25">
              <label class="form-check-label align-middle" id="selecionado4" for="25" @click="percent25">25%</label> 
            </div><!--percents-single-->
            </div><!--col-->

            <div class="col-4 percents">
              <div class="percents-single">
              <input class="form-check-input" name="num[]" type="radio" value="50" id="50">
              <label class="form-check-label align-middle" id="selecionado5" for="50" @click="percent50">50%</label> 
            </div><!--percents-single-->
            </div><!--col-->

            <div class="col-4 percents">
              <div class="percents-single">
              <input type="text" placeholder="custom" class="custom" v-model="percent" @keypress="tip"  id="custom"/>
            </div><!--percents-single-->
            </div><!--col-->
          </div><!--row-->
          <h5 class="title-people">Number of People</h5>
        <input type="text" id="pessoas" placeholder="0" v-model="pessoas" @keyup="soma"/>

        <div class="person"><img src="./assets/icon-person.svg"></div>
      </div><!--col-->

      <div class="col-xl-6 amount d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex w-100 justify-content-between justify-content-md-around align-items-center">
           <div class="tip-amount">
        <h5>Tip Amount</h5>
        <p>/ person</p>

        <h5 class="mt-4">Total</h5>
        <p>/ person</p>
        </div><!--tip-amount-->
        
        <div class="soma">
          <h2>R${{Math.floor(percentTotal)}}</h2>  
          <h2 class="mt-5">R${{Math.round(somaTotal)}}</h2>  
        </div><!--soma-->
        </div><!--flex-->
  
        <button @click="reset">Resetar</button>
        
      </div><!--col-->
        </div><!--row-->
      </div><!--container-->
  </div><!--box-->
</div>
</template>

<script>
import { ref } from 'vue';
export default {
  name: 'App',
  setup(){
    const bill= ref("");
    const pessoas = ref("");
    const somaTotal = ref("");
    const percent = ref("");
    const percentTotal = ref("");
    const checked5 = 5/100;
    const checked10 = 10/100;
    const checked15 = 15/100;
    const checked25 = 25/100;
    const checked50 = 50/100;
    
    const soma = ()=>{
        somaTotal.value = bill.value/pessoas.value+percentTotal.value;        
    }

    const tip = ()=>{
      percentTotal.value = percent.value/100*bill.value/pessoas.value; 
    }

     const percent5 = ()=>{
      percentTotal.value = checked5*bill.value/pessoas.value
      
    }

     const percent10 = ()=>{
      percentTotal.value = checked10*bill.value/pessoas.value; 
    }

     const percent15 = ()=>{
      percentTotal.value = checked15*bill.value/pessoas.value; 
    }

     const percent25 = ()=>{
      percentTotal.value = checked25*bill.value/pessoas.value; 
    }
     const percent50 = ()=>{
      percentTotal.value = checked50*bill.value/pessoas.value; 
    }

    const reset = ()=>{
     const formBill = document.getElementById("bill");
     const formPessoas = document.getElementById("pessoas");

      formBill.value = 0;
      formPessoas.value = 0;
      somaTotal.value = 0;
      percentTotal.value = 0;
      percent.value = 0;
    }
     
    return{
      bill,
      pessoas,
      somaTotal,
      soma,
      percent,
      tip,
      percentTotal,
      percent5,
      percent10,
      percent15,
      percent25,
      percent50,
      reset
    }
},

}

</script>

<style>
*{
  margin:0;
  padding:0;
  box-sizing: border-box;
  font-family: 'Space Mono', monospace;
}
#app {
  background:#c5e4e7;
  height: 100vh;
}

.active{
  background-color:#9fe8df !important;
}

.row{
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
}

.box{
  background-color:white;
  border-radius:10px;
  padding:30px;
}
h6{
  color:#708483;
}

.box input[type=text]{
  background:#f3f8fb;
  width: 100%;
  border: 0;
  padding: 0 8px;
  text-align: right;
  position: relative;
  cursor: pointer;
  font-size: 24px;
  color:#004d4e;
  font-weight: 700;
}
input[type=text]:focus{
  outline-color: #5aaaa1;
}

.dollar{
  padding: 0 10px;
}

.dollar img{
  position: relative;
  top:-32px;
}

h5.title-people{
  color:#71797b;
  font-weight: 700;
  font-size: 14px;
  margin:10px 0;
}

.form-check-input{
 display: none;
}

.form-check-input:checked > .form-check-label{
  background-color:#9fe8df;
  color:#034b48;
}

.form-check-label{
  background-color:#00474b;
  color: white;
  padding: 3px 10px;
  margin:5px 1px;
  border-radius:8px;
  font-size: 24px;
  display:flex;
  justify-content:center;
  align-items: center;
  text-align: center;
  cursor: pointer;
}


input[type=text].custom{
  background:#f3f8fb;
  font-size:24px;
  max-width: 155px;
  border: 0;
  cursor: pointer;
  color:#004d4e;
  font-weight: 700;
  text-align:right;
  margin:5px 1px;
}

.person{
  padding: 0 10px;
}

.person img{
  position: relative;
  top:-32px;
}
.amount{
  background-color:#00474b;
  border-radius:10px;
}

.amount h5{
  color:white;
  font-weight: 400;
}

.tip-amount p{
  color:#6d9ea3;
}

.soma h2{
  color:#20c4ac;
  font-size: 40px;
}

button{
  background-color:#9fe8df;
  color:#004441;
  border:0;
  border-radius: 5px;
  padding: 8px 50px;
  width: 90%;
  margin:10px 0;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  transform: translateX(-50%);
  position: relative;
  left: 50%;
}

button:disabled{
  background-color:#0d686d;
  color:white;
  border:0;
  border-radius: 5px;
  padding: 8px 50px;
  width: 90%;
  margin:10px 0;
  cursor: pointer;
  opacity: 0.5;
}

@media screen and (max-width: 768px){
  .amount{
    text-align: center;
    padding: 40px 30px;
  }

  .soma h2{
  color:#20c4ac;
  font-size: 30px;
}

.amount h5{
  color:white;
  font-weight: 400;
  font-size: 14px;
}
.row{
  padding-right: 0;
  padding-left: 0;
}
}

</style>
